import React from "react";

const LuminousFacialCustomer = () => {
  return (
    <div className="organicFacialCustomerContainer">
      <h5>Testimonials from Satisfied Clients</h5>
      <p>
        Located in the heart of Bangalore, SCENT is easily accessible, making it
        convenient for you to schedule and attend your facial appointments.
      </p>
      <div className="organicFacialCustomerContent">
        <p>
          <span className="quote">“</span>The Luminous Lightening Facial at
          SCENT has transformed my skin. My dark spots have lightened, and my
          complexion is so much brighter. I highly recommend it !{" "}
          <span className="quote">”</span> - <span> Priya S </span>
        </p>
        <p>
          <span className="quote">“</span> I love the personalized approach at
          SCENT. The estheticians are so knowledgeable, and the Luminous
          Lightening Facial has done wonders for my skin.
          <span className="quote">”</span> - <span>Anjali R. </span>
        </p>
        <p>
          <span className="quote">“</span>SCENT provides a luxurious and
          relaxing experience. The Luminous Lightening Facial has become my
          go-to treatment for maintaining youthful and radiant skin.{" "}
          <span className="quote">”</span> - <span>Ritu M. </span>
        </p>
      </div>
    </div>
  );
};

export default LuminousFacialCustomer;
